// Propósito: helpers puros de autenticación para AppComponent.
import { NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';

// Extrae el código OAuth desde la URL.
export function extractAuthCode(url: string): string | null {
  const match = url.match(/[?&]code=([^&]+)/);
  if (match) return decodeURIComponent(match[1]);
  return null;
}

// Detecta si la URL trae parámetro de código.
export function hasCodeParam(url: string): boolean {
  return url.includes('?code');
}

// Quita los query params dejando solo el path base.
export function stripCodeParam(url: string): string {
  return url.split('?')[0];
}

// Limpia el path cuando viene con código OAuth.
export function cleanLoggedPath(path: string): string {
  if (hasCodeParam(path)) return '';
  return path;
}

// Arma el mensaje de fallo con instrucción de reintento.
export function buildRetryMessage(message: string): string {
  return message + '. Recargue la página para reintentar.';
}

// Indica si pasó muy poco desde la última redirección a login.
export function inLoginCooldown(lastLoginAt: number, cooldownMs: number): boolean {
  return Date.now() - lastLoginAt < cooldownMs;
}

// Identifica eventos de navegación que controlan el loader.
export function isNavigationEvent(event: unknown): boolean {
  return isNavStart(event) || isNavEnd(event) || isNavCancel(event);
}

// Detecta inicio de navegación.
export function isNavStart(event: unknown): boolean {
  return event instanceof NavigationStart;
}

// Detecta fin de navegación.
export function isNavEnd(event: unknown): boolean {
  return event instanceof NavigationEnd;
}

// Detecta navegación cancelada o con error.
export function isNavCancel(event: unknown): boolean {
  return isCancelEvent(event) || isErrorEvent(event);
}

// Detecta evento de navegación cancelada.
export function isCancelEvent(event: unknown): boolean {
  return event instanceof NavigationCancel;
}

// Detecta evento de error de navegación.
export function isErrorEvent(event: unknown): boolean {
  return event instanceof NavigationError;
}
